import type { Connection } from '../../api/types';

/** Capability authorization comes from the current connector DB record via the API. */
export function supportsConnectionEditing(connection: Connection): boolean {
  return connection.connector.enabled
    && connection.connector.capabilities?.supports_connection_edit === true;
}

export function connectionEditBusy(connection: Connection): boolean {
  return ['syncing', 'authenticating', 'configuring'].includes(connection.status);
}